import React from 'react';
import { FilterComponentProps, SortComponentProps } from './types';
import { RadioSort } from '@app/[lang]/collections/collection-filters/control-types/radio-sort';

export function CollectionSortGroup({
    options,
    selectedSort,
    onSelectSort,
    ariaLabel,
    lang,
}: SortComponentProps): JSX.Element | null {
    return (
        <RadioSort
            options={options}
            selectedSort={selectedSort}
            ariaLabel={ariaLabel}
            onSelectSort={onSelectSort}
            lang={lang}
        />
    );
}
